module.exports = __webpack_public_path__ + "static/media/icon_select2.adb0f810.svg";